import { get, postJSON, del, post } from '../utils/axios'
import getUserInfo from '../utils/getUserInfo'

/**
 * getUserInfo() 用户登录信息
 * name    名称
    appId   AppID
    phone   手机号码
    pk  用户ID
    sysUserId   sysUser表的用户ID
    sysUserHeadUrl  sysUser表的用户头像
    orgPk   组织ID
    orgName 组织名称
    store   组织类型 0-集团 1-4S 2-维修（门店） 3-经销商（代理商）
    authorization   访问令牌
    tokenHead   访问令牌头前缀
    loginType   登录类型 默认APP
    enable  平台账号状态 1-启用 0-禁用
    loginNum    登陆APP端次数
 */


// 优米账户充值
interface rechargeProps {
    amount?: number //充值金额
    cashierAccountPk?: string //出纳账户pk
    cashierAccountType?: string //出纳账户类型：0-门店 1-服务商
    operName?: string //操作人
    operPk?: string //操作人pk
    orgName?: string //组织名称
    orgPk?: string //组织PK
    remark?: string //备注
}

export const setAccountRecharge = (options: rechargeProps) => postJSON('/payApi/cashierAccount/accountRecharge', options)

// 支付单号查询订单详情
export const getSelectPayOrderByPayOrderNo = (payOrderNo: string) => post('/payApi/payOrder/selectPayOrderByPayOrderNo', { payOrderNo })

/**
 * 调拨
 */
//出纳账户列表
export const getCashierAccountCfg = () => {
    const userInfo = getUserInfo()
    if (userInfo?.store === '2') {
        return get('cashierAccountCfg/selectCashierAccountList')
    }
    if (userInfo?.store === '3') {
        return postJSON('/yme-agency/cashierAccount/getCwCashierAccountList', {
            page: 1,
            size: 100
        })
    }
}

// 资金调拨列表头部统计
interface billListHeaderDataProps {
    orgPk?: string //门店pk
    page?: number //当前页
    pk?: string //PK
    billCode?: string //调拨单号
    size?: number //每页大小
    transferMode?: string //调拨方式 0-提现 1-账户间调拨
    billStatus?: string //状态0-调拨中 1-调拨成功 2-调拨失败 3-已作废
    transferOutAccountName?: string //调出账户名称
    startTime?: string //开始日期
    transferOutAmount?: string //调出余额
    endTime?: string //截止日期
    transferInAccountName?: string //调入账户名称
    minAmount?: string //调拨最小金额
    transferInAmount?: string //调入余额
    maxAmount?: string //调拨最大金额
    serviceAmount?: string //手续费
    failReason?: string //失败原因
    createrName?: string //制单人名称
    createTime?: string //制单时间
    cancellerName?: string //作废人名称
    cancelTime?: string //作废时间
    cancelReason?: string //作废原因
    remark?: string //备注
}

export const getBillListHeaderData = (options: billListHeaderDataProps) => {
    const userInfo = getUserInfo()
    if (userInfo?.store === '2') {
        return postJSON('/allocationBill/billListHeaderData', options)
    }
    if (userInfo?.store === '3') {
        return postJSON('/yme-agency/allocationBill/billListHeaderData', options)
    }
}

// 资金调拨方式列表
export const getAllocationBillTypeList = (options: billListHeaderDataProps) => {
    const userInfo = getUserInfo()
    if (userInfo?.store === '2') {
        return postJSON('allocationBill/allocationBillTypeList', options)
    }
    if (userInfo?.store === '3') {
        return postJSON('/yme-agency/allocationBill/allocationBillTypeList', options)
    }
}

// 资金调拨列表查询
export const getSelectAllocationBillList = (options: billListHeaderDataProps) => {
    const userInfo = getUserInfo()
    if (userInfo?.store === '2') {
        return postJSON('allocationBill/selectAllocationBillList', options)
    }
    if (userInfo?.store === '3') {
        return postJSON('/yme-agency/allocationBill/selectAllocationBillList', options)
    }
}

// 资金调拨
interface saveAllocationBillProps {
    transferOutAccountPk?: string //调出账户PK
    transferOutAmount?: string //调出余额
    transferInAccountPk?: string | number //调入账户PK
    serviceAmount?: string //手续费
    transferMode?: string //调拨方式 0-提现 1-账户间调拨
    remark?: string //备注
}
export const getSaveAllocationBill = (options: saveAllocationBillProps) => {
    const userInfo = getUserInfo()
    if (userInfo?.store === '2') {
        return postJSON('allocationBill/saveAllocationBill', options)
    }
    if (userInfo?.store === '3') {
        return postJSON('/yme-agency/allocationBill/saveAllocationBill', options)
    }
}

// 资金调拨单详情
export const getSelectAllocationBillDetailByBillPk = (billPk) => {
    const userInfo = getUserInfo()
    if (userInfo?.store === '2') {
        return post('/allocationBill/selectAllocationBillDetailByBillPk', { billPk })
    }
    if (userInfo?.store === '3') {
        return post('/yme-agency/allocationBill/selectAllocationBillDetailByBillPk', { billPk })
    }
}

// 修改审核资金调拨单状态
export const updateOrderAuditStatus = (options) => postJSON('/yme-agency/allocationBill/updateOrderAuditStatus', { ...options })


/**
 * 资金账户
 */

// 资金账户头部卡片滑动
export const getSelectAgentAccountList = () => {
    const userInfo = getUserInfo()
    let { orgPk } = userInfo
    if (userInfo?.store === '2') {
        return post('/payApi/cashierAccount/selectOrgAccountList', { orgPk })
    }
    if (userInfo?.store === '3') {
        return post('/payApi/cashierAccount/selectAgentAccountList', { orgPk })
    }
}

// 出纳账户收支统计（Ai优米账户使用，其他出纳账户独立接口）
interface penseStatisticsProps {
    businessType?: string //业务类型
    cashierAccountPk?: string //出纳账户pk
    cashierAccountType?: string //出纳账户类型 0-门店 1-服务商
    endTime?: string //截止日期
    orgPk?: string //门店/服务商pk
    page?: string | number //当前页
    size?: string | number //每页大小
    startTime?: string //开始日期
    type?: string //类型0-收入 1-支出
}
export const getAccountIncomeExpenseStatistics = (options: penseStatisticsProps) => postJSON('/payApi/accountIncomeExpense/accountIncomeExpenseStatistics', options)

// 出纳账户收支记录（Ai优米账户使用，其他出纳账户独立接口）
export const getSelectAccountIncomeExpenseDetailList = (options: penseStatisticsProps) => postJSON('/payApi/accountIncomeExpense/selectAccountIncomeExpenseDetailList', options)

// 付款支出失败重发
export const setTryEntpay = (expenseRecordPk: string) => post('/payApi/accountIncomeExpense/tryEntpay', { expenseRecordPk })

// Ai优米业务类型列表
export const getBusinessType = () => get('/payApi/common/businessType', {})

// 收支对象列表
export const getSelectInOrOutObjectLis = (options?) => postJSON('/payApi/accountIncomeExpense/selectInOrOutObjectList', options)

// 出纳账户收支统计（除Ai优米账户外，其他出纳账户调用 ）
export const getAccountListStatistics = (options: penseStatisticsProps) => {
    const userInfo = getUserInfo()
    if (userInfo?.store === '2') {
        return postJSON('busIncomeExpenseRecords/accountIncomeExpenseStatistics', options)
    }
    if (userInfo?.store === '3') {
        return postJSON('/yme-agency/busIncomeExpenseRecords/accountIncomeExpenseStatistics', options)
    }
}

// 出纳账户收支记录（除Ai优米账户外，其他出纳账户调用 ）
export const getSelectAccountlList = (options: penseStatisticsProps) => {
    const userInfo = getUserInfo()
    if (userInfo?.store === '2') {
        return postJSON('busIncomeExpenseRecords/selectAccountIncomeExpenseDetailList', options)
    }
    if (userInfo?.store === '3') {
        return postJSON('/yme-agency/busIncomeExpenseRecords/selectAccountIncomeExpenseDetailList', options)
    }
}

// 出纳账户类型列表（除Ai优米账户外，其他出纳账户调用 ）
export const getTypeList = () => {
    const userInfo = getUserInfo()
    if (userInfo?.store === '2') {
        return postJSON('busIncomeExpenseRecords/selectAccountIncomeExpenseTypeList')
    }
    if (userInfo?.store === '3') {
        return postJSON('/yme-agency/busIncomeExpenseRecords/selectAccountIncomeExpenseTypeList')
    }
}

//自动提现
interface autoWithdrawalsCfgProps {
    outCashierAccountPk?: string //转出出纳账户pk
    inCashierAccountPk?: string //转入出纳账户pk
    reserveAmount?: string //预留金额
    status?: string //状态 0-关闭 1-开启
    verificationCode?: string //验证码
}
export const autoWithdrawalsCfg = (options: autoWithdrawalsCfgProps) => postJSON(`automaticWithdrawals/autoWithdrawalsCfg`, { ...options })

//提现成功次数
export const allocationSuccessCount = (transferOutAccountPk: string) => post(`automaticWithdrawals/allocationSuccessCount`, { transferOutAccountPk })

//是否开启自动提现
export const isOpenAutoWithdrawals = (transferOutAccountPk: string) => post(`automaticWithdrawals/isOpenAutoWithdrawals`, { transferOutAccountPk })

//是否开启自动提现
export const selectAccountPk = (transferOutAccountPk: string) => post(`automaticWithdrawals/selectAccountPk`, { transferOutAccountPk })


// 新增编辑门店出纳账户
export const saveOrUpdate = (options: any) => postJSON(`cashierAccountCfg/saveOrUpdate`, options)

// 按服务商pk查询所有下级门店列表(包含子级+孙子级)
export const selectMerchantOrgList = (agentOrgPk: any, orgSimpleName?: any) => post(`org/selectMerchantOrgList`, {
    agentOrgPk,
    orgSimpleName
})
